import * as React from 'react';
import './CustomCardAffiliate.scss';
import { IconInfo } from '../../../../../assets/index';
import { formatMoney } from '../../../../../utils/helpers/helpers';
import { Button, Tooltip } from 'antd';
import { useHistory } from 'react-router-dom';
import { routePage } from '../../../../../utils/constants/constant';

const CustomCardAffiliate = (props) => {
  const { userAffiliationInfo, getInfoGeneralInfo } = props;
  const history = useHistory();
  return (
    <div className='custom-card-affiliate'>
      <div className='body-card-dashboard'>
        <div className='title-text-dashboard'>Cấp bậc đối tác</div>
        <div className='row-current-balance'>
          Doanh số
          <Tooltip
            placement='top'
            title='Doanh số bạn đạt được để hưởng mức hoa hồng tương ứng'
            style={{}}
          >
            <IconInfo style={{ marginLeft: 4 }} />
          </Tooltip>
        </div>
        <div className='money-text'>
          {`${formatMoney(userAffiliationInfo?.currentGMV || 0)}`}
          {/* <span className='max'>/25.000.000đ</span> */}
        </div>
        <div>VNĐ</div>
        <div className='row-current-balance'>
          Cấp bậc của bạn:
          <div className='box-level'>
            {userAffiliationInfo?.currentLevel || 0}
          </div>
        </div>
        <div className='deduct-text'>
          Hoa hồng cộng thêm: <span className='bold'>0%</span>
        </div>
        <div className='wrap-bonus'>
          <div>
            <span>- Khách sạn:</span>
            <span className='bold'>{` ${
              getInfoGeneralInfo()?.discount?.percent || 0
            }%`}</span>
          </div>
          <div>
            <span>- Vé máy bay:</span>
            <span className='bold'>
              {` ${formatMoney(
                getInfoGeneralInfo()?.discountFlight?.fixedAmount || 0
              )}VNĐ`}
            </span>
          </div>
          <div>
            <span>- Hàng tiêu dùng:</span>
            <span className='bold'>
              {` ${getInfoGeneralInfo()?.discountGrocery?.percent || 0}%`}
            </span>
          </div>
        </div>
        <div className='normal-text' style={{ marginTop: 16 }}>
          Mức doanh thu mục tiêu của cấp tiếp theo
        </div>
        <div className='bold-money-text'>
          {`${formatMoney(getInfoGeneralInfo().gmvUp || 0)}đ`}
        </div>
        <Button
          type='text'
          className='see-detail-text'
          onClick={() =>
            history.push(`${routePage.HELP.FAQS_HELP}?commission=true`)
          }
        >
          Xem chi tiết
        </Button>
      </div>
    </div>
  );
};

export default CustomCardAffiliate;
